import { CurrencyRupee } from "@mui/icons-material";
import {
  Checkbox,
  InputAdornment,
  Paper,
  TextField,
  Typography,
  Grow,
  Fade,
  Tooltip,
} from "@mui/material";
import { red } from "@mui/material/colors";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

const ServiceTypeConfigInputChip = ({
  service,
  type,
  value: _value,
  onChange,
  deleteIdsHandler = () => { },
  isDefault = false, // NEW: Added isDefault prop
}) => {
  const [selected, setSelected] = useState(false);
  const [value, setValue] = useState(0);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    if (_value) {
      setSelected(true);
      setValue(_value?.value);
    }
    setLoading(false);
  }, [_value]);

  if (!loading)
    return (
      <Fade in>
        <Tooltip
          title={isDefault ? "Default service types cannot be removed or modified" : ""}
          arrow
          placement="top"
        >
          <Paper
            key={type.id}
            sx={{
              display: "flex",
              alignItems: "center",
              p: 2,
              gap: 1,
              borderRadius: 2,
              backgroundColor: error ? red[50] : "",
            }}
            elevation={1}
          >
            <Checkbox
              checked={selected}
              disabled={isDefault} // NEW: Disable checkbox for default services
              onChange={(e) => {
                console.log({ type, _value, service });
                const checked = e.target.checked;
                const newType = {
                  ...type,
                  isInitial: _value?.isInitial,
                  serviceConfigId: _value?.serviceConfigId,
                };

                setSelected(e.target.checked);

                if (!checked) {
                  if (_value?.isInitial) {
                    deleteIdsHandler(_value?.serviceConfigId);
                  }
                  onChange(newType, service, "", checked);
                } else {
                  onChange(newType, service, "0");
                }
              }}
            />
            {type.icon && (
              <img
                src={type.icon}
                alt={type.name}
                width={32}
                height={32}
                style={{ borderRadius: 5 }}
              />
            )}
            <Typography variant="h6" fontSize={16} pl={1}>
              {type.name}
            </Typography>
            {selected && !isDefault && ( // NEW: Hide price input for default services
              <TextField
                error={error}
                value={value}
                onChange={(e) => {
                  if (e.target.value >= 0) {
                    setValue(e.target.value);
                  }
                  if (e.target.value) {
                    setError(false);
                  }
                }}
                autoFocus
                sx={{
                  minWidth: "120px",
                  maxWidth: "min-content",
                }}
                placeholder="0"
                size="small"
                color="success"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" sx={{}}>
                      <CurrencyRupee fontSize="16px" />
                    </InputAdornment>
                  ),
                }}
                type="number"
                onBlur={(e) => {
                  if (!e.target.value) {
                    toast("Value must be 0 or greater than 0");
                    setError(true);
                  } else {
                    onChange(
                      {
                        ...type,
                        isInitial: _value?.isInitial,
                        serviceConfigId: _value?.serviceConfigId,
                      },
                      service,
                      e.target.value
                    );
                    setError(false);
                  }
                }}
              />
            )}
          </Paper>
        </Tooltip>
      </Fade>
    );
};

export default ServiceTypeConfigInputChip;
